import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Overlay,
  Popover,
  Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import toast from "react-hot-toast";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import moment from "moment";
import { useParams } from "react-router-dom";

const AddProject = ({
  showAddProject,
  handleCloseAddProject,
  userDataId,
  getUserCv,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [associatedWith, setAssociatedWith] = useState("");
  const [projectUrl, setProjectUrl] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [display, setDisplay] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      name: name,
      description: description,
      associatedWith: associatedWith,
      projectUrl: projectUrl,
      startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
      startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
      endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
      endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
    };
    console.log("body", body);

    if (name === '' || projectUrl === '' || startDate === '' || endDate === '') {
      toast.error('Please fill all the required fields')
    } else {
      try {
        const res = await axios.post("/Resume/AddProject", body);
        toast.success(res.data.message);
        handleCloseAddProject();
        getUserCv();
        setName("");
        setDescription("");
        setAssociatedWith("");
        setProjectUrl("");
        setStartDate(null);
        setEndDate(null);
        setDisplay(false)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message);
        }
      }
    }
  };


  return (
    <>
      <Modal
        show={showAddProject}
        onHide={handleCloseAddProject}
        centered
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Add Project</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseAddProject} />
        </Modal.Header>
        <Modal.Body className="settings">

          <Row>
            {/* Skills Section */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="field">
                <Form.Label className="class-type">
                  Name <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Name"
                />
                {display && !name ? (
                  <span className="error_msg_lbl">Add Project Name </span>
                ) : null}
              </Form.Group>
            </Col>
            <Col md={6} className="mb-2">
              <Form.Group controlId="field">
                <Form.Label className="class-type">
                  Description
                </Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter Description"
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-2">
              <Form.Group controlId="field">
                <Form.Label className="class-type">
                  Associated With
                </Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={associatedWith}
                  onChange={(e) => setAssociatedWith(e.target.value)}
                  placeholder="Enter  Associated With"
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-2">
              <Form.Group controlId="field">
                <Form.Label className="class-type">
                  Project Url <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={projectUrl}
                  onChange={(e) => setProjectUrl(e.target.value)}
                  placeholder="Enter Project Url"
                />
                {display && !projectUrl ? (
                  <span className="error_msg_lbl">Add Project Url </span>
                ) : null}
              </Form.Group>
            </Col>
            <Col md={6} className="mb-2">
              <Form.Group controlId="endYear">
                <Form.Label className="class-type">Start Year <span style={{ color: "red" }}>*</span>

                </Form.Label>
                <Flatpickr
                  type="number"
                  value={startDate}
                  onChange={(date) => setStartDate(date[0])}
                  placeholder="Enter End Year"
                // disabled={isPresent}
                />
                {display && !startDate ? (
                  <span className="error_msg_lbl">Select Start Year </span>
                ) : null}
              </Form.Group>
            </Col>
            <Col md={6} className="mb-2">
              <Form.Group controlId="endYear">
                <Form.Label className="class-type">End Year <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Flatpickr
                  type="number"
                  value={endDate}
                  onChange={(date) => setEndDate(date[0])}
                  placeholder="Enter End Year"
                  //   disabled={isPresent}
                  options={{
                    minDate: startDate || null, // Set minDate to startDate
                  }}
                />
                {display && !endDate ? (
                  <span className="error_msg_lbl">Select End Year </span>
                ) : null}
              </Form.Group>
            </Col>
          </Row>

          {/* Submit Button */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddProject;
